/**
 * Quyền cập nhật tiến độ lịch sử liên hệ:
 * - Có quyền C trên crm.contact_history
 * - super_admin, hoặc người tạo, hoặc cùng chi nhánh với người tạo
 * - fallback: cùng chi nhánh khách nếu thiếu staff
 */
export function getCurrentUserLite() {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
}

export function isSuperAdminUser(user = getCurrentUserLite()) {
  const names = [];
  const roles = user?.roles;
  if (Array.isArray(roles)) names.push(...roles);
  names.push(user?.role, user?.role_code, user?.role_name);
  return names.some((r) => {
    const n = String(r || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
    return (
      n.includes("super_admin") ||
      n === "super admin" ||
      n === "superadmin" ||
      n === "administrator" ||
      n === "system administrator"
    );
  });
}

export function getCurrentUserBranchId(user = getCurrentUserLite()) {
  return (
    user?.branch?.id ||
    user?.branch_id ||
    user?.branchId ||
    user?.owner_branch_id ||
    ""
  );
}

export function canProgressUpdateContact(contact, options = {}) {
  const {
    user = getCurrentUserLite(),
    hasCreatePermission = false,
  } = options;

  if (!contact || !hasCreatePermission) return false;
  if (isSuperAdminUser(user)) return true;

  const userId = user?.id ? String(user.id) : "";
  const myBranch = String(getCurrentUserBranchId(user) || "");
  const staffId = contact.staff_id ? String(contact.staff_id) : "";
  const staffBranch = contact.staff_branch_id
    ? String(contact.staff_branch_id)
    : "";
  const customerBranch = contact.branch_id ? String(contact.branch_id) : "";

  if (userId && staffId && userId === staffId) return true;
  if (myBranch && staffBranch && myBranch === staffBranch) return true;
  if (!staffBranch && myBranch && customerBranch && myBranch === customerBranch) {
    return true;
  }
  return false;
}
